<template>
  <div v-if="isAdminPortal">
    <button class="btn btn-link px-0" @click="checkShippingPackagesByCategory" :disabled="populating">
      <i v-if="populating" class="far fa-spinner-third fa-spin"></i> Update
      <span v-if="!category">All Product</span> Shipping Dimensions
    </button>
    <i
      class="fas fa-question-circle ml-1 text-light"
      v-b-tooltip.hover
      :title="`Auto populate shipping with data from the average of all shipping packages for all products that belong to this category`"
    ></i>
    <div class="progress flex-fill mt-1" v-if="checking">
      <div class="progress-bar" role="progressbar" :style="`width: ${checking}%;`">{{ checking }}%</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PopulateShippingDimension',
  props: ['category'],
  data() {
    return {
      timeOut: 0,
      checking: 0,
      populating: false
    };
  },
  methods: {
    async checkShippingPackagesByCategory() {
      try {
        this.populating = true;
        if (!this.category) {
          await this.check(1);
        } else {
          const { data } = await this.http.get(`/categories/${this.category._id}/average-shipping-packages`);
          this.$emit('change', data);
        }
      } catch (e) {
        console.log(e);
        this.notificateError(`Bad dimension: ${e.data.message || e}`);
      } finally {
        this.populating = false;
        if (!this.category) {
          this.populating = this.checking > 0;
        }
      }
    },
    async check(isStart) {
      if (!this.category) {
        try {
          this.populating = true;
          this.checking =
            parseFloat(
              ((await this.http[isStart ? 'post' : 'get'](`/categories/average-shipping-packages`)).data || 0).toFixed(
                2
              )
            ) * 100;
          this.populating = this.checking > 0;
          if (this.populating)
            this.timeOut = setTimeout(() => {
              this.check();
            }, 10000);
        } catch (e) {
        } finally {
          this.populating = this.checking > 0;
        }
      }
    }
  },
  destroyed() {
    if (this.timeOut) clearTimeout(this.timeOut);
  },
  async created() {
    this.check();
  }
};
</script>
